export var ExitType;
(function (ExitType) {
    ExitType["Default"] = "default";
    ExitType["Quote"] = "quote";
    ExitType["Base"] = "base";
})(ExitType || (ExitType = {}));
export var StrategyType;
(function (StrategyType) {
    StrategyType["Arithmetic"] = "arithmetic";
    StrategyType["ArithmeticLP"] = "trailing_arithmetic_lp";
    StrategyType["Geometric"] = "geometric";
})(StrategyType || (StrategyType = {}));
//# sourceMappingURL=types.js.map